export default __webpack_public_path__ + "static/media/007-balloons.cde69397.svg";